import React from 'react';

export const VimeoVideo = ({ vimeoId, autoplay, muted, loop }) => {
  // Build URL params
  const params = ['badge=0', 'autopause=0', 'player_id=0', 'app_id=151623'];

  if (autoplay) params.push('autoplay=1');
  if (muted) params.push('muted=1');
  if (loop) params.push('loop=1');

  const src = `https://player.vimeo.com/video/${vimeoId}?${params.join('&')}`;

  // Build allow attribute
  const allowParts = ['autoplay', 'fullscreen'];
  if (muted) allowParts.push('muted');

  return (
    <div
      className="video"
      style={{
        position: 'relative',
        paddingBottom: '56.25%' /* 16:9 */,
        height: 0,
        overflow: 'hidden',
      }}
    >
      <iframe
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
        src={src}
        allow={allowParts.join('; ')}
        allowFullScreen
        title={vimeoId}
      />
    </div>
  );
};
